/* eslint-disable no-console */
/* eslint-disable max-len */
import React, { useState, useRef } from 'react';
import { Box, Modal, Grid, Tooltip } from '@mui/material';
import { Rnd } from 'react-rnd';
import { closeIconBlack, reportErrorImage, reportWarningImage } from '../../shared/assets/images';
import { defaultModalOptions, fatalMarkersData, warningMarkerData } from '../../shared/constantVariable';
import Notification from '../../shared/notification-modal';
import './report.scss';

const ReportWinflow = (props) => {
  const { visiableError, handleCloseOption, reportErrorListData, activeIndexVal, translateObject } = props;
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  const uniSumeryDetails = useRef([]);
  // const getErrorLength = (data, str) => {
  //   let count = 0;
  //   if (data.length) {
  //     for (let i = 0; i < data.length; i += 1) {
  //       if (data[i].toLowerCase().indexOf(str) === 0) {
  //         count += 1;
  //       }
  //     }
  //   }
  //   return count;
  // };
  const getErrorLength = (data, fatalMarkers) => {
    let count = 0;
    if (Array.isArray(data) && data.length) {
      for (let i = 0; i < data.length; i += 1) {
        const lowerText = data[i].toLowerCase();
        const hasFatal = fatalMarkers.some(marker =>
          lowerText.startsWith(marker.toLowerCase())
        );
        if (hasFatal) {
          count += 1;
        }
      }
    }
    return count;
  };
  const [activeIndex, setActiveIndex] = useState(activeIndexVal);
  const headerSelected = (index) => {
    if (index === activeIndex) {
      setActiveIndex(-1);
    } else {
      setActiveIndex(index);
    }
  };
  const openAccordian = (event, ind) => {
    if (uniSumeryDetails.current[ind].classList.contains('active')) {
      setTimeout(() => {
        uniSumeryDetails.current.forEach((ele) => {
          ele.removeAttribute('open');
          ele.classList.remove('active');
        });
      }, 10);
    } else {
      uniSumeryDetails.current.forEach((ele) => {
        ele.removeAttribute('open');
        ele.classList.remove('active');
      });
      uniSumeryDetails.current[ind].classList.add('active');
    }
  };

  // const cleanMessage = (raw) => {
  //   return raw
  //     .replace(/\\r/g, '')                 // Remove escaped carriage returns
  //     .replace(/[“”]/g, '')                // Remove all curly quotes
  //     .replace(/\\n/g, '\n')               // Convert escaped newlines to actual line breaks
  //     .replace(/\\"/g, '')                 // Remove escaped double quotes
  //     .replace(/"\s*\+\s*/g, '')           // Remove "+ inside quotes
  //     .replace(/\s*\+\s*/g, '')            // Remove standalone + signs
  //     .replace(/""/g, '')                  // Remove double quotes
  //     .replace(/"/g, '')                   // Remove remaining quotes
  //     .replace(/\\+/g, '')                 // Remove stray backslashes
  //     // .replace(/\n{2,}/g, '\n')            // Collapse multiple newlines
  //     .trim();                             // Trim leading/trailing whitespace
  // };
  const getContecntData = (errlist) => {
    return errlist.slice(errlist.indexOf('\n') + 1);
  };

  return (
    <Modal
      hideBackdrop
      open={visiableError}
      onClose={handleCloseOption}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
      className="splitter-modal"
    >
      <Box>
        <Rnd
          default={{
            width: '50%',
            x: ((window.innerWidth / 2) - ((50 * (window.innerWidth / 100)) / 2)),
            y: ((window.innerHeight / 2) - ((50 * (window.innerHeight / 100)) / 2)),
          }}
          enableResizing={{
            bottom: false, bottomLeft: false, bottomRight: false,
            left: true, right: true,
            top: false, topLeft: false, topRight: false
          }}
          allowAnyClick
          enableUserSelectHack={false}
          resizeHandleStyles={{ 'right': { 'width': '5px' } }} // reducing width of right handle to 5px ---> kranthi
          minWidth='35%'
          cancel='.no_drag'
          className='report-box'>
          <Notification
            options={modalOption}
            handleClose={() => setModalOption(defaultModalOptions)}
          />
          <Grid container className='report-grid-container'>
            <Grid item xs={12} className='report-header-grid'>
              <div className='report-header-text ft rufusBld no_drag'>
                {translateObject('Notifications')}
              </div>
              <div className='report-close-icon no_drag'>
                <Tooltip title="Close">
                  <img src={closeIconBlack} alt="close" onClick={handleCloseOption} style={{ display: 'block' }} className="pointer" />
                </Tooltip>
              </div>
            </Grid>
            <Grid item xs={12} className='report-body-container'>
              <Box sx={{ width: '100%', typography: 'body1', height: '100%' }} className='mixer-box-container report-cart-popup'>
                <div className='report-cart-content'>
                  <section className="details-group">
                    {reportErrorListData.map((unitopData, unitopind) => (
                      <div key={`aa${Math.random().toString(36).slice(2, 7)}`} className={`unit_group ${activeIndex === unitopind ? 'active' : ''} ${unitopData.data.length ? '' : 'hide'}`}>
                        <h2 onClick={() => { headerSelected(unitopind); }} className='' >
                          <span className="icon_plus no_drag" />
                          <span className="unitop-name no_drag">{unitopData.name}
                            <span className='vetPipeLine'>&nbsp;&#124;</span></span>
                          {(getErrorLength(unitopData.data, warningMarkerData) > 0) && (
                            <span className="icon_unit warning_icon no_drag">
                              <img src={reportWarningImage} alt="warning" />
                              {getErrorLength(unitopData.data, warningMarkerData)}
                            </span>
                          )}
                          {(getErrorLength(unitopData.data, fatalMarkersData) > 0) && (
                            <span className="icon_unit error_icon no_drag">
                              <img src={reportErrorImage} alt="error" />
                              {getErrorLength(unitopData.data, fatalMarkersData)}
                            </span>
                          )}
                          {/* {(getErrorLength(unitopData.data, 'fatal error') > 0) && (
                            <span className="icon_unit error_icon no_drag">
                              <img src={reportErrorImage} alt="error" />
                              {getErrorLength(unitopData.data, 'fatal error')}
                            </span>
                          )} */}
                        </h2>
                        <div className="uni_sumerry">
                          {unitopData.data.map((errdata, errind) => {
                            const errwarstr = errdata; // cleanMessage(errdata);
                            return (
                              <details
                                ref={el => { uniSumeryDetails.current[errind] = el; }}
                                className={`details ${getContecntData(errwarstr).length === 0 ? 'disabled' : ''}`}
                                key={`bb${Math.random().toString(36).slice(2, 7)}`}
                              >
                                <summary className="details__summary" onClick={(event) => { openAccordian(event, errind); }}>
                                  {warningMarkerData.some(marker => errwarstr.toLowerCase().startsWith(marker.toLowerCase())) && (
                                    <img className="icon_title" src={reportWarningImage} alt="warning" />
                                  )}
                                  {fatalMarkersData.some(marker => errwarstr.toLowerCase().startsWith(marker.toLowerCase())) && (
                                    <img className="icon_title" src={reportErrorImage} alt="error" />
                                  )}
                                  {/* {(errwarstr.toLowerCase().indexOf('warning') === 0) && (
                                  <img className="icon_title" src={reportWarningImage} alt="warning" />
                                )} */}
                                  {/* {(errwarstr.toLowerCase().indexOf('fatal error') === 0) && (
                                  <img className="icon_title" src={reportErrorImage} alt="error" />
                                )} */}
                                  <span className="sansW4SeLig no_drag">{errwarstr.split('\n')[0]}</span>
                                </summary>
                                <div className="details__content">
                                  <p className="sansW4SeLig no_drag">{getContecntData(errwarstr)}</p>
                                </div>
                              </details>
                            );
                          }
                          )}
                        </div>
                      </div>
                    ))}
                  </section>
                </div>
              </Box>
            </Grid>
          </Grid>
        </Rnd>
      </Box>
    </Modal>
  );
};
export default ReportWinflow;